<template>
    <div class="selected-notams-main">

        <div class="notification is-white" v-for="(text,index) in LocalselectedNotams" :key="index">
            <p><span @click="DeleteNotams(text)" class="icon"><font-awesome-icon icon="star" size="2x"/></span></p>
            <br>
            <p><span @click="modalevent(text)" class="icon"> <font-awesome-icon icon="search-plus" size="2x"/></span></p>
            <pre>
                {{text.NotamInfo}}
            </pre>
            <hr>
        </div>
        <div class="modal" :class="{'is-active': showModalFlag}">
            <button @click="modalevent()" class="modal-close is-large" aria-label="close"></button>
            <div class="modal-background"></div>
            <div class="modal-content">
                <pre class="modal-windows">{{modaldata}}</pre>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        name: "SelectedNotams",
        data() {
            return {
                LocalselectedNotams: [],
                showModalFlag : false,
                modaldata :"",
            }
        },

        computed: {

            ...mapState("ipadmain",["FKey1", "selectedFlightItems","EFF_Json_Data","WR_Json_Data"]),
            ...mapState("selectednotams",["SelectedNotams"]),

        },

        created(){

            this.LocalselectedNotams = this.SelectedNotams;

        },

        methods:{

            DeleteNotams(text){
                this.LocalselectedNotams.splice(this.LocalselectedNotams.indexOf(text),1);
             //   this.SelectedNotams.splice(this.SelectedNotams.indexOf(text),1);

            },

            modalevent(text)
            {
                this.showModalFlag = !this.showModalFlag;
                this.modaldata = text;
            }

        }

    }


</script>

<style scoped>
    .modal-windows{
        background-color: #3892bd;
        color: unset;
        font-size: 1.2rem;
        padding: unset;
        font-weight: bold;

    }
    .modal{
        position: sticky;
        background-color: #fff;
        color: #fff;
        top: 15%;
        border-radius: .25rem;
        left: 10%;
        bottom: 40%;
        width: 80%;
        height: 15%;
    }
    .modal-close{
        height: 37px;
        width: 37px;
        position: sticky;
        left: 92%;
        z-index: 999;
        background-color: #999999;
    }
    .modal-background{
        background-color: #3892bd;
    }
    .modal-content{
        padding: 1.2rem;
    }
</style>
